import { useEffect, useState } from "react";
import getLandingData from "../api-route/landingpage";
import ArtSection from "../Components/arts-section/index.section";
import ArtistsSection from "../Components/artists-section/index.section";
import CategortSection from '../Components/categories-section/index'
import HeroHeader from "../Components/hero-header-section/index.section";
import { getBanner } from "../api-route/baner.js";

export default function Home() {
  const [response, setResponse] = useState()

  const [texts, setTexts] = useState({ baner: [] })
  useEffect(() => {
    const get = async () => {
      const data = await getBanner(1)
      setTexts(data ? data : {})
    }
    get()
  }, []);

  useEffect(() => {
    const get = async () => {
      const response = await getLandingData()
      setResponse(response)
    }
    get()
  }, [])

  return (
    <>
      <HeroHeader {...texts} withButton />
      {!!response &&
        <>
          <main className="flex flex-col py">
            <ArtSection initData={response.paintings} />

            <ArtistsSection data={response.artists} />
            <CategortSection data={response.categories} />
          </main>
        </>
      }
    </>
  );
}